import { NgModule } from '@angular/core';
import { ContractsModule } from './my-contracts/contracts.module';
import { RequestsModule } from './my-requests/requests.module';
import { InvoicesModule } from './my-invoices/invoices.module';
import { PaymentModule } from './my-payments/payment.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { LanguageModule } from './admin/my-language/language.module';
import { UsersModule } from './admin/my-users/users.module';
import { AssetsModule } from './my-assets/assets.module';
import { LogsModule } from './my-agentSyncLogs/logs.module';
import { AdminUsersModule } from './admin/my-admin-users/admin-users.module';
import { RequestsModule as AdministratorRequestsModule } from './admin/my-requests/requests.module';
import { ProfileModule } from './my-profile/my-profile.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { EmailsModule } from './admin/my-emails/emails.module';
import { AboutModule } from './about/about.module';
import { TermsAndConditionsModule } from './admin/my-terms-and-conditions/terms-and-conditions.module';
import { FrequentlyAskedQuestionsModule } from './faq/faq.module';
import { FrequentlyAskedQuestionsModule as AdministratorFrequentlyAskedQuestionsModule } from './admin/my-faq/faq.module';
import { InsurancesModule } from './my-insurances/insurances.module';
import { SpecialOffersModule } from './special-offers/special-offers.module';
import { SpecialOffersAdminModule } from './special-offers-admin/special-offers-admin.module';
import { AppDashboardModule } from './app-dashboard/app-dashboard.module';
import { AssetsDriverModule } from './my-assets-driver/assets-driver.module';
import { AssetsFleetManagementModule } from './assets-fleet-management/assets-fllet-management.module';
import { AdminContractsModule } from './admin/my-contracts/contracts.module';

@NgModule({
  imports: [
    ContractsModule,
    AdminContractsModule,
    RequestsModule,
    InvoicesModule,
    PaymentModule,
    UsersModule,
    LanguageModule,
    AppDashboardModule,
    DashboardModule,
    LogsModule,
    AdminUsersModule,
    AssetsModule,
    AssetsDriverModule,
    AdministratorRequestsModule,
    ProfileModule,
    ClipboardModule,
    EmailsModule,
    AboutModule,
    TermsAndConditionsModule,
    FrequentlyAskedQuestionsModule,
    AdministratorFrequentlyAskedQuestionsModule,
    InsurancesModule,
    SpecialOffersModule,
    SpecialOffersAdminModule,
    AssetsFleetManagementModule,
  ],

  declarations: [],
})
export class FeaturesModule {}
